@if (returnUrl()) {
  @if (isComplete()) {
    <div data-testid="profile-gate-ready"
      class="alert alert-success mb-4 flex items-center justify-between flex-wrap gap-3"
      role="status" aria-live="polite">
      <div class="flex items-center gap-3 min-w-0">
        <app-icon name="check_circle" class="flex-shrink-0"></app-icon>
        <span>Thanks - that's everything we needed. Your course is ready.</span>
      </div>
      <a data-testid="profile-gate-continue"
        [routerLink]="returnUrl()"
        class="btn btn-primary btn-sm flex-shrink-0">Go to my course</a>
    </div>
  } @else {
    <div data-testid="profile-gate-banner"
      class="alert alert-info mb-4 flex items-start gap-3"
      role="status" aria-live="polite">
      <app-icon name="assignment_ind" class="flex-shrink-0"></app-icon>
      <div class="min-w-0">
        <p class="font-semibold">Finish your profile - this course will not open until you do</p>
        <p>
          A few details are required by your organization before you can start
          a course. Scroll down to My Information, fill in every item marked
          {{ fieldBadgeLabel }}, and press Save on each one. Your course opens as soon as
          they are all saved.
        </p>
      </div>
    </div>
  }
}
